import { Navigate, Outlet } from 'react-router-dom';

import { UserType } from 'domain/types';
import { useComponent } from 'hooks';
import { useUser } from 'hooks/queries';

export const GcvRoute: React.FC = useComponent(() => {
  let isGcvuser = false;

  const { user } = useUser();

  if (user?.id && user?.type === UserType.GCV) isGcvuser = true;

  return isGcvuser ? <Outlet /> : <Navigate to={{ pathname: '/' }} />;
});
